import { api } from '@/api/api';
import { ApiManager } from '../api_manager';
import eventImpl from '../impl/api_data/__event/event_impl';
import dataStoreImpl from '../impl/api_data/_store/data_store_impl';
import daxieDbImpl from '../impl/api_data/db/daxie_db_impl';
import daxieMemoryImpl from '../impl/api_data/db/daxie_memory_impl';
import dbInterfaceImpl from '../impl/api_data/db/db_interface_impl';
import htmlImpl from '../impl/api_data/html/html_impl';
import httpImpl from '../impl/api_data/http/http_impl';
import dataTrackerImpl from '../impl/api_system/data_tracker/data_tracker_impl';
import eventLoggerImpl from '../impl/api_system/data_tracker/event_logger_impl';
import errorReportImpl from '../impl/api_system/error_report/error_report_impl';
import fileImpl from '../impl/api_system/file_impl';
import keyboardImpl from '../impl/api_system/keyboard/keyboard_impl';
import performanceImpl from '../impl/api_system/performance/performance_impl';
import systemImpl from '../impl/api_system/system_impl';
import taskImpl from '../impl/api_system/task/task_impl';
import loginImpl from '../impl/logical/_login/login_impl';
import accountImpl from '../impl/logical/account/account_impl';
import insertWhatsAppImpl from '../impl/logical/account/insertWhatsApp_impl';
import addressBookImpl from '../impl/logical/address_book/address_book_impl';
import addressBooknewImpl from '../impl/logical/address_book/address_booknew_impl';
import advertImpl from '../impl/logical/advert/advert_impl';
import agcOpImpl from '../impl/logical/agc_op/agc_op_impl';
import aiAssistantImpl from '../impl/logical/ai_assistant/ai_assistant_impl';
import aiAsstWmImpl from '../impl/logical/ai_asst_wm/ai_asst_wm_impl';
import aiStaffImpl from '../impl/logical/ai_staff/ai_staff_impl';
import approvalFlowImpl from '../impl/logical/approval_flow_impl.ts/approval_flow_impl';
import autoMarketImpl from '../impl/logical/auto_market/auto_market_impl';
import catalogImpl from '../impl/logical/catalog/catalog_impl';
import configSettingImpl from '../impl/logical/configSetting/config_setting_impl';
import contactImpl from '../impl/logical/contact/contact_impl';
import convertImpl from '../impl/logical/convert/convert_impl';
import customerDiscoveryImpl from '../impl/logical/customer/customerDiscovery_impl';
import customerImpl from '../impl/logical/customer/customer_impl';
import fieldSettingImpl from '../impl/logical/customer/fieldSetting_impl';
import saleStageImpl from '../impl/logical/customer/saleStage_impl';
import aiHostingImpl from '../impl/logical/edm/ai_hosting_impl';
import customsImpl from '../impl/logical/edm/customs_impl';
import edmMenuImpl from '../impl/logical/edm/edm_menu_impl';
import edmNotifyImpl from '../impl/logical/edm/edm_notify_impl';
import globalSearchImpl from '../impl/logical/edm/global_search_impl';
import productDataImpl from '../impl/logical/edm/product_data_impl';
import roleImpl from '../impl/logical/edm/role_impl';
import sendboxImpl from '../impl/logical/edm/sendbox_impl';
import emptyImpl from '../impl/logical/emptyApi/empty_impl';
import facebookImpl from '../impl/logical/facebook/facebook_impl';
import feedbackImpl from '../impl/logical/feedback/feedback_impl';
import ffmsImpl from '../impl/logical/ffms/ffms_impl';
import globalGuideImpl from '../impl/logical/globalGuide/global_guide_impl';
import icsImpl from '../impl/logical/ics/ics_impl';
import imDiscussImpl from '../impl/logical/im/im_discuss_impl';
import imImpl from '../impl/logical/im/im_impl';
import imTeamImpl from '../impl/logical/im/im_team_impl';
import kfImpl from '../impl/logical/kf/kf_impl';
import mailAutoReplyImpl from '../impl/logical/mail/mail_auto_reply_impl';
import mailBlacklistImpl from '../impl/logical/mail/mail_blacklist_impl';
import mailConfImpl from '../impl/logical/mail/mail_conf_impl';
import mailDraftImpl from '../impl/logical/mail/mail_draft_impl';
import mailImpl from '../impl/logical/mail/mail_impl';
import mailPraiseImpl from '../impl/logical/mail/mail_praise_impl';
import mailProductImpl from '../impl/logical/mail/mail_product_impl';
import mailSignatureImpl from '../impl/logical/mail/mail_signature_impl';
import mailStrangerImpl from '../impl/logical/mail/mail_stranger_impl';
import mailTemplateImpl from '../impl/logical/mail/mail_template_impl';
import mailPlusCustomerImpl from '../impl/logical/mail_plus_customer/mail_plus_customer_impl';
import mailStatusImpl from '../impl/logical/mail_status/mail_status_impl';
import materielImpl from '../impl/logical/materiel/materiel_impl';
import netStorageImpl from '../impl/logical/net_storage/net_storage_impl';
import netStorageShareImpl from '../impl/logical/net_storage/net_storage_share_impl';
import notificationCenterImpl from '../impl/logical/notification_center/notification_center_impl';
import npsImpl from '../impl/logical/nps/nps_impl';
import productAuthImpl from '../impl/logical/product_auth/product_auth_impl';
import pushImpl from '../impl/logical/push/push_impl';
import registerImpl from '../impl/logical/register/register_impl';
import remindersImpl from '../impl/logical/reminders/reminders_impl';
import safeBrowsingImpl from '../impl/logical/safe_browsing/safe_browsing_impl';
import salesPitchImpl from '../impl/logical/salesPitch/sales_pitch_impl';
import siteImpl from '../impl/logical/site/site_impl';
import snsMarketingImpl from '../impl/logical/sns_marketing/sns_marketing_impl';
import taskCenterImpl from '../impl/logical/task_center/task_center_impl';
import taskmailImpl from '../impl/logical/taskmail/taskmail_impl';
import autoTestImpl from '../impl/logical/test_api/auto_test_impl';
import upgradeAppImpl from '../impl/logical/upgradeApp/upgrade_app_impl';
import webmailImpl from '../impl/logical/webmail/webmail_impl';
import whatsAppImpl from '../impl/logical/whatsApp/whatsApp_impl';
import windowHooksImpl from '../impl/logical/windowHooks/window_hooks_impl';
import worktableImpl from '../impl/logical/worktable/worktable_impl';
import { inWindow } from '@/config';
api.registerLogicalApi(eventImpl);
api.registerLogicalApi(dataStoreImpl);
api.registerLogicalApi(daxieDbImpl);
api.registerLogicalApi(daxieMemoryImpl);
api.registerLogicalApi(dbInterfaceImpl);
api.registerLogicalApi(htmlImpl);
api.registerLogicalApi(httpImpl);
api.registerLogicalApi(dataTrackerImpl);
api.registerLogicalApi(eventLoggerImpl);
api.registerLogicalApi(errorReportImpl);
api.registerLogicalApi(fileImpl);
api.registerLogicalApi(keyboardImpl);
api.registerLogicalApi(performanceImpl);
api.registerLogicalApi(systemImpl);
api.registerLogicalApi(taskImpl);
api.registerLogicalApi(loginImpl);
api.registerLogicalApi(accountImpl);
api.registerLogicalApi(insertWhatsAppImpl);
api.registerLogicalApi(addressBookImpl);
api.registerLogicalApi(addressBooknewImpl);
api.registerLogicalApi(advertImpl);
api.registerLogicalApi(agcOpImpl);
api.registerLogicalApi(aiAssistantImpl);
api.registerLogicalApi(aiAsstWmImpl);
api.registerLogicalApi(aiStaffImpl);
api.registerLogicalApi(approvalFlowImpl);
api.registerLogicalApi(autoMarketImpl);
api.registerLogicalApi(catalogImpl);
api.registerLogicalApi(configSettingImpl);
api.registerLogicalApi(contactImpl);
api.registerLogicalApi(convertImpl);
api.registerLogicalApi(customerDiscoveryImpl);
api.registerLogicalApi(customerImpl);
api.registerLogicalApi(fieldSettingImpl);
api.registerLogicalApi(saleStageImpl);
api.registerLogicalApi(aiHostingImpl);
api.registerLogicalApi(customsImpl);
api.registerLogicalApi(edmMenuImpl);
api.registerLogicalApi(edmNotifyImpl);
api.registerLogicalApi(globalSearchImpl);
api.registerLogicalApi(productDataImpl);
api.registerLogicalApi(roleImpl);
api.registerLogicalApi(sendboxImpl);
api.registerLogicalApi(emptyImpl);
api.registerLogicalApi(facebookImpl);
api.registerLogicalApi(feedbackImpl);
api.registerLogicalApi(ffmsImpl);
api.registerLogicalApi(globalGuideImpl);
api.registerLogicalApi(icsImpl);
api.registerLogicalApi(imDiscussImpl);
api.registerLogicalApi(imImpl);
api.registerLogicalApi(imTeamImpl);
api.registerLogicalApi(kfImpl);
api.registerLogicalApi(mailAutoReplyImpl);
api.registerLogicalApi(mailBlacklistImpl);
api.registerLogicalApi(mailConfImpl);
api.registerLogicalApi(mailDraftImpl);
api.registerLogicalApi(mailImpl);
api.registerLogicalApi(mailPraiseImpl);
api.registerLogicalApi(mailProductImpl);
api.registerLogicalApi(mailSignatureImpl);
api.registerLogicalApi(mailStrangerImpl);
api.registerLogicalApi(mailTemplateImpl);
api.registerLogicalApi(mailPlusCustomerImpl);
api.registerLogicalApi(mailStatusImpl);
api.registerLogicalApi(materielImpl);
api.registerLogicalApi(netStorageImpl);
api.registerLogicalApi(netStorageShareImpl);
api.registerLogicalApi(notificationCenterImpl);
api.registerLogicalApi(npsImpl);
api.registerLogicalApi(productAuthImpl);
api.registerLogicalApi(pushImpl);
api.registerLogicalApi(registerImpl);
api.registerLogicalApi(remindersImpl);
api.registerLogicalApi(safeBrowsingImpl);
api.registerLogicalApi(salesPitchImpl);
api.registerLogicalApi(siteImpl);
api.registerLogicalApi(snsMarketingImpl);
api.registerLogicalApi(taskCenterImpl);
api.registerLogicalApi(taskmailImpl);
api.registerLogicalApi(autoTestImpl);
api.registerLogicalApi(upgradeAppImpl);
api.registerLogicalApi(webmailImpl);
api.registerLogicalApi(whatsAppImpl);
api.registerLogicalApi(windowHooksImpl);
api.registerLogicalApi(worktableImpl);
const apis = [
    eventImpl.name, dataStoreImpl.name, daxieDbImpl.name, daxieMemoryImpl.name, dbInterfaceImpl.name, htmlImpl.name, httpImpl.name, dataTrackerImpl.name, eventLoggerImpl.name, errorReportImpl.name, fileImpl.name, keyboardImpl.name, performanceImpl.name, systemImpl.name, taskImpl.name, loginImpl.name, accountImpl.name, insertWhatsAppImpl.name, addressBookImpl.name, addressBooknewImpl.name, advertImpl.name, agcOpImpl.name, aiAssistantImpl.name, aiAsstWmImpl.name, aiStaffImpl.name, approvalFlowImpl.name, autoMarketImpl.name, catalogImpl.name, configSettingImpl.name, contactImpl.name, convertImpl.name, customerDiscoveryImpl.name, customerImpl.name, fieldSettingImpl.name, saleStageImpl.name, aiHostingImpl.name, customsImpl.name, edmMenuImpl.name, edmNotifyImpl.name, globalSearchImpl.name, productDataImpl.name, roleImpl.name, sendboxImpl.name, emptyImpl.name, facebookImpl.name, feedbackImpl.name, ffmsImpl.name, globalGuideImpl.name, icsImpl.name, imDiscussImpl.name, imImpl.name, imTeamImpl.name, kfImpl.name, mailAutoReplyImpl.name, mailBlacklistImpl.name, mailConfImpl.name, mailDraftImpl.name, mailImpl.name, mailPraiseImpl.name, mailProductImpl.name, mailSignatureImpl.name, mailStrangerImpl.name, mailTemplateImpl.name, mailPlusCustomerImpl.name, mailStatusImpl.name, materielImpl.name, netStorageImpl.name, netStorageShareImpl.name, notificationCenterImpl.name, npsImpl.name, productAuthImpl.name, pushImpl.name, registerImpl.name, remindersImpl.name, safeBrowsingImpl.name, salesPitchImpl.name, siteImpl.name, snsMarketingImpl.name, taskCenterImpl.name, taskmailImpl.name, autoTestImpl.name, upgradeAppImpl.name, webmailImpl.name, whatsAppImpl.name, windowHooksImpl.name, worktableImpl.name
];
const am = new ApiManager(apis);
export const initApi = () => {
    if (inWindow()) {
        am.triggerApiLifeCycleEvent({
            event: 'init',
            curPath: location,
        });
    }
};
export const apisManager = am;
export default apis;
